export default __webpack_public_path__ + "static/media/delphus_full_white.7f4cf722.png";